/* eslint-disable no-case-declarations */
import { PRESUPUESTADOR_SELECT_LINEA_FINANCIERA } from './constants'
import { validateCapMaxFinanciacion } from './BFFUtils'

export function selectLineaFinanciera(selectedLineaFinanciera, montoAfinanciar, cuotasAfinanciar) {
  return (dispatch, getState) => {
    const { presupuestador } = getState(state => state);

    const {maxCap, cuotasAfinanciar: cuotasAfinanciarCalculada, lineExists} = validateCapMaxFinanciacion(
      presupuestador.lineasFinancieras,
      selectedLineaFinanciera || presupuestador.credit_line_id,
      cuotasAfinanciar,
      presupuestador.nuevo?.bonification,
      presupuestador?.nuevo?.reference_price,
      presupuestador?.nuevo?.net_sale_price,
      presupuestador.special_discount,
      presupuestador?.nuevo?.nuevo
    )
    
    dispatch({
      type: PRESUPUESTADOR_SELECT_LINEA_FINANCIERA,
      data: { selectedLineaFinanciera, cuotasAfinanciar: cuotasAfinanciarCalculada, montoAfinanciar: montoAfinanciar || maxCap , maxCap, lineExists},
    })
  }
}
export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_SELECT_LINEA_FINANCIERA:
      const { selectedLineaFinanciera, cuotasAfinanciar, montoAfinanciar, maxCap, lineExists } = action.data
      if (!selectedLineaFinanciera || !lineExists) {
        return {
          ...state,
          selectedLineaFinanciera: null,
          cuotasAfinanciar: 0,
          montoAfinanciar: 0,
          gastosFinanciacion: 0,
          credit_line_dcosts: 0,
          maxCap : 0,
          cft: 0,
          valorPrimeraCuota: 0,
          cuotaProm: 0,
          sortFinancialLine: 'TASA'
        }
      }
      return {
        ...state,
        selectedLineaFinanciera,
        cuotasAfinanciar: cuotasAfinanciar || state.cuotasAfinanciar,
        montoAfinanciar: montoAfinanciar || state.montoAfinanciar,
        cuotaProm: state.credit_line_avg_fees,
        maxCap: maxCap || state.maxCap,
        errorAmount: false
      }
    default:
      return state
  }
}
